export default __webpack_public_path__ + "static/media/container-orange.86c0ee99.svg";